import React from 'react';
import DropDownMenu from '../DropDownMenu';
import SignUpPanel from '../../../auth/SignUpPanel';

type SignUpLinkProps = {
	active: boolean;
	className?: string;
	onClick: () => void;
	onClose: () => void;
	onNavigate: () => void;
	backIcon?: string;
};

export default function SignUpLink(props: SignUpLinkProps) {
	const { active, className, onClick, onClose, onNavigate, backIcon } = props;

	return (
		<DropDownMenu
			className={`signup-link-menu ${className ?? ''}`}
			navItemClassName="auth-links signup-link"
			active={active}
			header={
				// A native button, like DropDownTextMenu, so it can be tabbed to and opened with the keyboard.
				<button type="button" className="drop-btn" aria-expanded={active} onClick={onClick}>
					<span>sign up</span>
				</button>
			}
		>
			<SignUpPanel onClose={onClose} onNavigate={onNavigate} backIcon={backIcon} />
		</DropDownMenu>
	);
}
